import React from "react"

const Header3 = (props) => (
  <h3 style={{ padding: "0 20px" }}>{props.children}</h3>
)

export default Header3
